import PropTypes from 'prop-types';

export default {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};



// WEBPACK FOOTER //
// ../utils/proptypes/react-intl.js